import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMetroComponent } from './simple-icons-metro.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMetroComponent ],
    exports:      [ SimpleIconsMetroComponent ],
    bootstrap:    []
})
export class SimpleIconsMetroModule {}
